import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveIpv4Groups } from '../../shared/components';

export type CreateIpv4GroupProps = {};

const CreateIpv4Group: React.FC<CreateIpv4GroupProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_grupoipv4);

  return <SaveIpv4Groups titlePage="Crear Grupo IPv4" />;
};

export default CreateIpv4Group;
